// import React from "react";
// const InvoicesWithRequstsSection = ({
//   arPhrase,
//   enPhrase,
//   lang,
//   requests,
//   selectedRequests,
//   onToggleRequest,
//   getRequestUniqueKey
// }) => {
//   return (
//     <div className="flex flex-col gap-[32px]">
//       {requests.map((request, index) => {
//         // Create an isolated key for each item loop using index protection
//         const itemKey = getRequestUniqueKey(request, index);
//         const isChecked = selectedRequests.includes(itemKey);

//         return (
//           <div key={itemKey} className="flex flex-col gap-[16px]">
//             <div
//               className={`border !border-[#E6D7A2] rounded-[8px] p-[16px] gap-[16px] flex flex-col transition-colors duration-200 ${
//                 isChecked ? "bg-[#B68A351A]" : "bg-[#FFFFFF]"
//               }`}
//             >
//               <div className="flex flex-row items-center justify-between">
//                 <div className="flex flex-row gap-[8px] md:gap-[16px]">
//                   <input
//                     type="checkbox"
//                     checked={isChecked}
//                     onChange={() => onToggleRequest(itemKey)}
//                     className="w-4 h-4 rounded text-[#af8c45] focus:ring-[#af8c45] cursor-pointer"
//                   />
//                   <div>
//                     <div className="flex flex-row items-start gap-[8px] md:gap-[24px] ">
//                       <div className="flex flex-col justify-start gap-[4px]  ">
//                         <p className="text-[12px] md:text-[14px] font-normal leading-[18px] md:leading-[24px] text-[#6F6A62]">
//                           {lang === "en"
//                             ? enPhrase["lblApplicationNumber"]
//                             : arPhrase["lblApplicationNumber"]}
//                         </p>
//                         <p className="text-[12px] md:text-[14px] font-bold leading-[18px] md:leading-[24px] !max-w-[64px] md:!max-w-fit text-[#0E0D0C] break-words">
//                           {request?.id}
//                         </p>
//                       </div>
//                       <img src="/assets/img/invoices/Line.svg" alt="" />
//                       <div className="flex flex-col justify-start gap-[4px] ">
//                         <p className="text-[12px] md:text-[14px] font-normal leading-[18px] md:leading-[24px] text-[#6F6A62]">
//                           {lang === "en"
//                             ? enPhrase["lblApplicationTypeDot"]
//                             : arPhrase["lblApplicationTypeDot"]}
//                         </p>
//                         <p className="text-[12px] md:text-[14px] font-bold leading-[18px] md:leading-[24px] !max-w-[100px] md:!max-w-fit text-[#0E0D0C] break-words ">
//                           {request?.serviceCategory}
//                         </p>
//                       </div>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="flex items-center gap-[4px] border !border-[#F2C99B] rounded-[16px] py-[4px] px-[8px]">
//                   <img src="/assets/img/invoices/Rectangle.svg" alt="" className="w-[9px] h-[9px]" />
//                   <span className="text-[12px] md:text-[14px] text-[#6F6A62] font-Almarai font-bold leading-[16px] md:leading-[24px]">
//                     {request?.status}
//                   </span>
//                 </div>
//               </div>

//               <div className="border border-[#A3A3A340]"></div>

//               <div className="flex flex-row items-center justify-between">
//                 <div className="flex flex-col justify-start gap-[4px]  ">
//                   <p className="text-[12px] md:text-[14px] font-normal leading-[18px] md:leading-[24px] text-[#6F6A62]">
//                     {lang === "en" ? enPhrase["lblCaseType"] : arPhrase["lblCaseType"]}
//                   </p>
//                   <p className="text-[12px] md:text-[14px] font-bold leading-[18px] md:leading-[24px] !max-w-[100px] md:!max-w-fit text-[#0E0D0C] break-words">
//                     {request?.caseTypeName}
//                   </p>
//                 </div>

//                 <div className="flex flex-row items-center gap-[8px] md:gap-[24px]">
//                   <div className="flex flex-col justify-start gap-[4px]  ">
//                     <p className="text-[12px] md:text-[14px] font-normal leading-[18px] md:leading-[24px] text-[#6F6A62]">
//                       {lang === "en" ? enPhrase["lblAmountVat"] : arPhrase["lblAmountVat"]}
//                     </p>
//                     <div className={`flex ${lang === "en" ? "flex-row-reverse" : ""} gap-[3px] items-center justify-center`}>
//                       <p className="text-[12px] md:text-[18px] text-[#0E0D0C] font-Almarai font- md:font-bold">
//                         {request?.vatValue}
//                       </p>
//                       <span className="text-muted text-[12px] md:small text-decoration-line-through !text-[#0E0D0C] flex items-center h-full">
//                         <span className="uae-symbol !text-[12px] md:!text-[18px] !text-[#0E0D0C] leading-[18px] md:font-bold" lang="en" dir="ltr">
//                           &#x00EA;
//                         </span>
//                       </span>
//                     </div>
//                   </div>
//                   <img src="/assets/img/invoices/Line.svg" alt="" />
//                   <div className="flex flex-col justify-start gap-[4px]  ">
//                     <p className="text-[12px] md:text-[14px] font-normal leading-[18px] md:leading-[24px] text-[#6F6A62]">
//                       {lang === "en" ? enPhrase["lblClaimedValue"] : arPhrase["lblClaimedValue"]}
//                     </p>
//                     <div className={`flex ${lang === "en" ? "flex-row-reverse" : ""} gap-[3px] items-center justify-center`}>
//                       <p className="text-[12px] md:text-[18px] text-[#A98031] font-Almarai font- md:font-bold">
//                         {request?.excludingVAT}
//                       </p>
//                       <span className="text-muted small text-decoration-line-through !text-[#A98031] flex items-center h-full">
//                         <span className="uae-symbol !text-[12px] md:!text-[18px] !text-[#A98031] leading-[18px] md:font-bold" lang="en" dir="ltr">
//                           &#x00EA;
//                         </span>
//                       </span>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         );
//       })}
//     </div>
//   );
// };

// export default InvoicesWithRequstsSection;

import React from "react";

const InvoicesWithRequstsSection = ({
  arPhrase,
  enPhrase,
  lang,
  requests = [],
  selectedRequests = [],
  onToggleRequest,
  getRequestUniqueKey,
}) => {
  return (
    <div className="flex flex-col gap-[32px]">
      {requests.map((request, index) => {
        const itemKey = getRequestUniqueKey
          ? getRequestUniqueKey(request, index)
          : (request?.id ?? index);

        const isChecked = selectedRequests.includes(itemKey);

        return (
          <div key={itemKey} className="flex flex-col gap-[16px]">
            <label
              className={`border !border-[#E6D7A2] rounded-[8px] p-[16px] gap-[16px] flex flex-col cursor-pointer transition-all duration-200 ${
                isChecked
                  ? "bg-[#B68A351A] !border-[#B68A35]"
                  : "bg-[#FFFFFF] hover:bg-[#B68A350D]"
              }`}
            >
              <div className="flex flex-row items-center justify-between">
                <div className="flex flex-row gap-[8px] md:gap-[16px]">
                  <input
                    type="checkbox"
                    checked={isChecked}
                    onChange={() => onToggleRequest(itemKey)}
                    className="w-4 h-4 shrink-0 rounded text-[#af8c45] focus:ring-[#af8c45] cursor-pointer"
                  />

                  <div>
                    <div className="flex flex-row items-start gap-[8px] md:gap-[24px]">
                      <div className="flex flex-col justify-start gap-[4px]">
                        <p className="text-[12px] md:text-[14px] font-normal leading-[18px] md:leading-[24px] text-[#6F6A62]">
                          {lang === "en"
                            ? enPhrase["lblApplicationNumber"]
                            : arPhrase["lblApplicationNumber"]}
                        </p>

                        <p className="text-[12px] md:text-[14px] font-bold leading-[18px] md:leading-[24px] !max-w-[64px] md:!max-w-fit text-[#0E0D0C] break-words">
                          {request?.id}
                        </p>
                      </div>

                      <img
                        src="/assets/img/invoices/Line.svg"
                        alt=""
                        className="self-stretch"
                      />

                      <div className="flex flex-col justify-start gap-[4px]">
                        <p className="text-[12px] md:text-[14px] font-normal leading-[18px] md:leading-[24px] text-[#6F6A62]">
                          {lang === "en"
                            ? enPhrase["lblApplicationTypeDot"]
                            : arPhrase["lblApplicationTypeDot"]}
                        </p>

                        <p className="text-[12px] md:text-[14px] font-bold leading-[18px] md:leading-[24px] !max-w-[100px] md:!max-w-fit text-[#0E0D0C] break-words">
                          {request?.serviceCategory}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="flex items-center gap-[4px] border !border-[#F2C99B] rounded-[16px] py-[4px] px-[8px]">
                  <img
                    src="/assets/img/invoices/Rectangle.svg"
                    alt=""
                    className="w-[9px] h-[9px]"
                  />

                  <span className="text-[12px] md:text-[14px] text-[#6F6A62] font-Almarai font-bold leading-[16px] md:leading-[24px]">
                    {request?.status}
                  </span>
                </div>
              </div>

              <div className="border border-[#A3A3A340]" />

              <div className="flex flex-row items-center justify-between">
                <div className="flex flex-col justify-start gap-[4px]">
                  <p className="text-[12px] md:text-[14px] font-normal leading-[18px] md:leading-[24px] text-[#6F6A62]">
                    {lang === "en"
                      ? enPhrase["lblCaseType"]
                      : arPhrase["lblCaseType"]}
                  </p>

                  <p className="text-[12px] md:text-[14px] font-bold leading-[18px] md:leading-[24px] !max-w-[100px] md:!max-w-fit text-[#0E0D0C] break-words">
                    {request?.caseTypeName}
                  </p>
                </div>

                <div className="flex flex-row items-center gap-[8px] md:gap-[24px]">
                  <div className="flex flex-col justify-start gap-[4px]">
                    <p className="text-[12px] md:text-[14px] font-normal leading-[18px] md:leading-[24px] text-[#6F6A62]">
                      {lang === "en"
                        ? enPhrase["lblAmountVat"]
                        : arPhrase["lblAmountVat"]}
                    </p>

                    <div
                      className={`flex ${
                        lang === "en" ? "flex-row-reverse justify-end" : "justify-start"
                      } gap-[3px] items-center `}
                    >
                      <p className="text-[12px] md:text-[16px] text-[#0E0D0C] font-Almarai font-bold md:font-normal">
                        {request?.vatValue}
                      </p>

                      <span className="text-muted text-[12px] md:small text-decoration-line-through !text-[#0E0D0C] flex items-center h-full">
                        <span
                          className="uae-symbol !text-[12px] md:!text-[16px] !text-[#0E0D0C] leading-[18px] font-bold md:font-normal"
                          lang="en"
                          dir="ltr"
                        >
                          &#x00EA;
                        </span>
                      </span>
                    </div>
                  </div>

                  <img
                    src="/assets/img/invoices/Line.svg"
                    alt=""
                    className="self-stretch"
                  />

                  <div className="flex flex-col justify-start gap-[4px]">
                    <p className="text-[12px] md:text-[14px] font-normal leading-[18px] md:leading-[24px] text-[#6F6A62]">
                      {lang === "en"
                        ? enPhrase["lblClaimedValue"]
                        : arPhrase["lblClaimedValue"]}
                    </p>

                    <div
                      className={`flex ${
                        lang === "en" ? "flex-row-reverse justify-start" : "justify-end"
                      } gap-[3px] items-center `}
                    >
                      <p className="text-[12px] md:text-[16px] text-[#A98031] font-Almarai font-bold md:font-normal">
                        {request?.excludingVAT}
                      </p>

                      <span className="text-muted small text-decoration-line-through !text-[#A98031] flex items-center h-full">
                        <span
                          className="uae-symbol !text-[12px] md:!text-[16px] !text-[#A98031] leading-[18px] font-bold md:font-normal"
                          lang="en"
                          dir="ltr"
                        >
                          &#x00EA;
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </label>
          </div>
        );
      })}
    </div>
  );
};

export default InvoicesWithRequstsSection;
